import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, Validators, FormControl, FormBuilder } from '@angular/forms';
import { EntityService } from '../../entity.service';
import { E } from '@angular/cdk/keycodes';
// import SecureLS from 'secure-ls';
// var ls = new SecureLS({ encodingType: 'base64' });
import moment from "moment";
import { FuseAlertType } from '@fuse/components/alert';
import ls from 'localstorage-slim';
@Component({
  selector: 'app-add-holidays',
  templateUrl: './add-holidays.component.html'
})
export class AddHolidaysComponent implements OnInit {

  constructor(public _matDialogRef: MatDialogRef<AddHolidaysComponent>, public _holidayService: EntityService, @Inject(MAT_DIALOG_DATA) public dialogData: any) { }
  holidayForm: FormGroup;
  dateLst;
  hndlr_nm
  enty_ky
  editData
  hdng_nm
  sve_btn
  clntTntDtls: any;
  showAlert: boolean = false;
  alert: { type: FuseAlertType; message: string } = {
    type: 'success',
    message: ''
  };
  ngOnInit(): void {
    if (ls.get('hms_loggedin_user_clients')) {
      this.clntTntDtls = JSON.parse(ls.get('hms_loggedin_user_clients'));
      console.log(this.clntTntDtls);
    }
    this.holidayForm = new FormGroup({
      "date_id": new FormControl('', Validators.required),
      "hldy_nm": new FormControl(''),
      "dsc_txt": new FormControl('')
    });
    console.log(this.dialogData);
    if (this.dialogData) {
      if (this.dialogData.edit_in) {
        this.hndlr_nm = this.dialogData.hndlr_nm;
        this.enty_ky = this.dialogData.enty_ky;
        this.editData = this.dialogData.editData;
        this.hdng_nm = 'Edit';
        this.sve_btn = 'Update';
        this.edtFnc()
      }
      else {
        this.hndlr_nm = this.dialogData.hndlr_nm;
        this.enty_ky = this.dialogData.enty_ky;
        this.hdng_nm = 'Add';
        this.sve_btn = 'Add';
        this.edtFnc()
      }

    }
    else {
      this.hndlr_nm = 'client'
      this.enty_ky = this.clntTntDtls[0].clnt_id
      this.hdng_nm = 'Add';
      this.sve_btn = 'Add';
      this.edtFnc()
    }


  }
  Close(): void {
    this._matDialogRef.close();
  }
  send() {
    console.log(this.holidayForm.controls);
    if(this.holidayForm.value.date_id){
      this.holidayForm.controls['hldy_nm'].setValidators([Validators.required])
      this.holidayForm.controls['hldy_nm'].updateValueAndValidity()
  }
    var count = 0;
    Object.keys(this.holidayForm.controls).forEach((key: string) => {
      if (this.holidayForm.controls[key].status == "INVALID") {
        console.log(key);
        if (key == 'date_id') {
          this.alert = {
            type: 'error',
            message: 'Please choose Date'
          }
        } if (key == 'hldy_nm') {
          this.alert = {
            type: 'error',
            message: 'Please enter Holiday name'
          }
        }
        this.showAlert = true;
      }
      if (this.holidayForm.controls[key].status == "VALID") {
        count++;
        if (count == Object.keys(this.holidayForm.value).length) {
          this.showAlert = false;
          this.saveHldys();
        }

      }
    });
  }


  saveHldys() {
    this.showAlert = false;
    let data = {
      dt: moment(this.holidayForm.value.date_id).format('YYYY-MM-DD'),
      hldy_nm: this.holidayForm.value.hldy_nm,
      desc: this.holidayForm.value.dsc_txt,
      hndlr_nm: this.hndlr_nm,
      enty_ky: this.enty_ky
    }
    console.log(data);
    if (this.editData) {
      this.holidayForm.value['hndlr_nm'] = this.hndlr_nm,
        this.holidayForm.value['enty_ky'] = this.enty_ky,
        this.holidayForm.value['hldy_id'] = this.editData.hldy_id,
        this.holidayForm.value['date_id'] = data.dt,
        this.holidayForm.value['dt'] = data.dt,
        this.holidayForm.value['dt_id'] = this.editData.dt_id,
        console.log('UPDATE -------------------', this.holidayForm.value)
      this._holidayService.updteHoliday(this.holidayForm.value).subscribe((res) => {
        if (res['status'] == 200) {
          this._holidayService.openSnackBar(res['message'], 'primary');
          this.holidayForm.reset()
          this._matDialogRef.close();
        }
        else {
          this._holidayService.openSnackBar(res['message'], 'warn');
        }

      })
    }
    else {
        this._holidayService.addHoliday(data).subscribe((res: any) => {
          if (res.status == 200) {
            this.holidayForm.reset()
              this._matDialogRef.close();
              this._holidayService.openSnackBar('Added holiday successfully', 'primary')
          }else {
            this._holidayService.openSnackBar(res['message'], 'warn');
          }
      }, (err) => {
      })

    }
  }

  // getDates() {
  //   this._holidayService.getDatesLst().subscribe(res => {
  //     if (res['status'] == 404) {
  //       this._holidayService.openSnackBar(res['message'], 'amber');
  //     } else if (res['status'] == 200) {
  //       // this.custom_loader = false;
  //       this.dateLst = res['data'];
  //       console.log(this.dateLst);
  //       if (this.editData) {
  //         this.edtFnc()
  //       }
  //     }
  //     else {
  //     }
  //   });
  // }

  onDateChange(e) {
    console.log(e);
  }


  edtFnc() {
    let updtDt = moment.utc(this.editData.dt, 'DD MMM YYYY').format("YYYY-MM-DD");
    console.log(updtDt);
    this.holidayForm.get('date_id').setValue(updtDt)
    this.holidayForm.get('hldy_nm').setValue(this.editData.hldy_nm)
    this.holidayForm.get('dsc_txt').setValue(this.editData.dscn_tx)
  }
}
